<!-- 
<div class="bg-white p-0 rounded-lg  max-w-md w-full relative">
    <h2 class="text-2xl font-semibold mb-4">{{data.name}}</h2>
    <div class="flex flex-col mb-6">
        <p>Email: {{data.email}}</p>
        <p>Contact: {{data.phone}}</p>
        <mat-icon class="icon-size-8 absolute top-2 right-2 text-gray-600" svgIcon="heroicons_outline:x-circle" (click)="closeModal()"></mat-icon>
    </div>
    <button class="bg-red-500 text-white px-4 py-2 rounded" (click)="closeModal()">Close</button>
</div> -->
<section class="w-full h-full ">

    <mat-icon class="icon-size-8 absolute top-2 right-2 text-gray-600" svgIcon="heroicons_outline:x-circle" (click)="closeModal()"></mat-icon>
    <div class="w-full p-6 relative h-[400px] bg-cover  bg-no-repeat bg-center  mt-6 flex flex-col justify-center "  [style.background-image]="'url(' + data.imageUrl + ')'">
        <div class="absolute inset-0 bg-gradient-to-t from-gray-900 via-gray-900/40"></div>
        <!-- <h1 class="z-10  text-7xl text-left text-white text-shadow font-extrabold uppercase "> {{view.page?.content.name}} </h1> -->
        <h1 class="z-10  text-7xl text-left text-white text-shadow font-extrabold uppercase border-b-2 border-primary-700 max-w-128"> Blog </h1>
        <!-- <span class="w-60 border-b-4 border-primary-700 "></span> -->
        <p class="z-10 text-xl text-white font-light pt-2">
            {{data.title}}
        </p>
    </div>
    <div class="w-full flex flex-col items-center bg-white" id="about">
        <div class="w-full flex flex-col p-8 max-w-[800px] text-center -mt-16 absolute bg-white">
            <div class="w-full p-6  text-center  ring-2 ring-primary ">

                <!-- <h1 class="text-accent-500 text-center  font-light  text-4xl  w-[100%] mx-auto">
                    Whitestar Cruise & Travel is Your Premier Cruise Operator in Southern Africa!
                </h1> -->
                <p class="text-gray-500 text-center font-light font-bold pt-4 pb-4 w-[100%]  mx-auto">
                    {{data.description}}
                </p>
            </div>
        </div>
        <button class="bg-red-500 text-white px-4 py-2 rounded" (click)="closeModal()">Close</button>
    </div>
</section>
    <!-- <button class="bg-red-500 text-white px-4 py-2 rounded" (click)="closeModal()">Close</button> -->
